import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DownloadIcon,
  ShareIcon
} from "../../front-end-global-components/assets/assets";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import Header from "../../front-end-global-components/components/Header/Header";
import { setErrorStatus } from "../../redux/status/actions";
import { getPatientCardDetails } from "../../services/api";
import "./ShowAbdmInfo.css";

function AbdmCard(props) {
  const [cardURILoading, setCardURILoading] = useState(false);
  const [dataUrl, setDataUrl] = useState(null);
  const navigate = useNavigate();

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = "image.jpg";
    link.click();
  };

  const handleShare = async () => {
    const blob = await (await fetch(dataUrl)).blob();
    const file = new File([blob], `${props.type} details.png`, {
      type: blob.type
    });
    if (!!navigator && navigator?.canShare?.({ files: [file] })) {
      await navigator?.share({
        title: "Ninto",
        text: `Ninto - ${props.type}`,
        url: window.location.href,
        files: [file]
      });
    }
  };

  const getData = async () => {
    setCardURILoading(true);
    try {
      const { auth, patients, abdm } = props;

      const { currentProfile, accessToken } = patients;
      const abdmToken = accessToken?.[currentProfile]?.token;

      if (typeof abdmToken !== "string") {
        // setErrorStatus({
        //   code: "custom",
        //   message: "Invalid accessToken or requestId or reason"
        // });
        // return;
        console.warn("no access token", currentProfile);
      }

      const result = await getPatientCardDetails(
        auth.data.accessToken,
        abdmToken,
        abdm.newHealthNumberData?.token || null,
        currentProfile,
        props.type
      );

      if (
        // result?.success === true &&
        result?.data &&
        typeof result?.data === "string"
      ) {
        setDataUrl(result.data);
      } else {
        console.warn("custom", "failed to fetch");
      }
    } catch (error) {
      console.error(error);
      setErrorStatus({
        code: "custom",
        message: "Unable to get Card details"
      });
    }
    setCardURILoading(false);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.patients.accessToken]);

  const data = [
    {
      title: "download",
      click: () => {
        handleDownload();
      },
      "data-cy": "ABHA-CARD-DOWNLOAD-BUTTON",
      icon: <DownloadIcon />,
      name: "Download"
    },
    {
      title: "share",
      click: () => {
        handleShare();
      },
      "data-cy": "ABHA-CARD-SHARE-BUTTON",
      icon: <ShareIcon />,
      name: "Share"
    }
  ];

  return (
    <div className="inherit-parent-height">
      <Header
        title={props.type}
        backButtonOnClick={() => {
          navigate(-1);
        }}
        supportIconOnClick={() => {
          navigate("/query");
        }}
        incident={props.app.featureFlags?.incident?.patients}
        incidentOnClick={() => {
          navigate("/incidents");
        }}
      />

      {!props.app.featureFlags?.abhaService && (
        <FeatureFlagsFallback height={"remaining-body-height"} />
      )}

      {props.app.featureFlags?.abhaService && (
        <>
          <div className="inherit-parent-width text-align-center padding-larger">
            ABHA ADDRESS INFORMATION
          </div>
          <main className="display-flex flex-justify-content-center overflow-hidden padding-top-larger padding-bottom-larger position-relative ">
            {cardURILoading === true ? (
              <div className="background-color-white padding-left-default padding-right-default padding-top-small padding-bottom-small border-radius-default ">
                <div className="loading-spinner" data-cy="LOADING-SPINNER" />
              </div>
            ) : cardURILoading === false && dataUrl ? (
              <div className="flex-justify-content-center ">
                <img
                  style={{
                    width: "190%"
                  }}
                  alt="qr"
                  src={dataUrl}
                  data-cy="ABHA-CARD"
                />
              </div>
            ) : (
              <p>No ABHA card Details</p>
            )}
          </main>
          {cardURILoading === false && dataUrl && (
            <div className="display-flex inherit-parent-width overflow-hidden flex-justify-content-space-between border-top-2px-solid-e5e5e5 position-absolute position-bottom-0">
              {data.map((data, index) => (
                <div
                  index={index}
                  style={{
                    width: "124px"
                  }}
                  className="padding-left-larger padding-right-larger padding-top-default padding-bottom-default display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
                  data-cy={data?.["data-cy"]}
                  onClick={data.click}
                >
                  <div>{data.icon}</div>
                  <div className="">{data.name}</div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  abdm: state.abdm,
  patients: state.patients,
  app: state.app
});

const mapDispatchToProps = () => {
  return {
    setErrorStatus: (payload) => setErrorStatus(payload)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AbdmCard);
